
import { FirearmEntityDecorator } from '../../firearm/model/firearm.decorator';
import { Firearm } from '../../firearm/model/firearm.model';
import { FIREARM_ASSIGNMENT_LOG_METADATA } from './firearm-assignment-log.metadata';
import { FirearmAssignmentLog } from './firearm-assignment-log.model';
import { FirearmAssignmentEntityDecorator } from './firearm-assignment.decorator';
import { FirearmAssignment } from './firearm-assignment.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class FirearmAssignmentLogEntityDecoratorBase extends GenericEntityDecorator<FirearmAssignmentLog, number> {
  constructor() {
    super(FIREARM_ASSIGNMENT_LOG_METADATA, {
      get assignments(): EntityDecorator<FirearmAssignment, number> {
        return new FirearmAssignmentEntityDecorator();
      },
      get firearm(): EntityDecorator<Firearm, number> {
        return new FirearmEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.assetId == null) {
      return null;
    }
    return parseInt(params.assetId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: FirearmAssignmentLog): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




